import { CheckboxToggleInput } from '@/components/CheckboxToggleInput'

import { LayerToggleOption } from './LayerManager.types'

import styles from './LayerManager.module.css'

export type LayerToggleProps = LayerToggleOption & {
  testId?: string
}

export const LayerToggle = ({ value, setValue, name, testId }: LayerToggleProps) => {
  return (
    <CheckboxToggleInput
      className={styles.layerToggle}
      checked={value}
      onChange={(e) => setValue(e.target.checked)}
      data-testid={testId}
    >
      {name}
    </CheckboxToggleInput>
  )
}
